<template>
  <material-card
    color="dover-blue">
    <div>
      <v-flex
        xs12
        md12>
        <material-card
          v-bind="{ title: getTitle(), text: getText() }"
          :key="componentKey"
          color="dover-blue">
          <div>
            <v-flex
              xs12
              md12>
              <v-tabs
                fixed-tabs
                color="dover-blue"
                slider-color="yellow"
                dark
                icons-and-text>
                <v-tab
                  :key="0"
                  ripple>
                  {{ $t('Settings') }}
                  <v-icon>mdi-settings</v-icon>
                </v-tab>
                <v-tab-item
                  :key="0">
                  <MaglinkLineLeakConfigDetail
                    :is-new-lld="isNewLld"
                    :lld="lld"
                    :tanks="tanks"
                    @dataChanged="onDataChanged" />
                </v-tab-item>
                <v-tab
                  :key="1"
                  ripple>
                  {{ $t('Pipeline') }}
                  <v-icon>mdi-pipe</v-icon>
                </v-tab>
                <v-tab-item
                  :key="1">
                  <MaglinkLineLeakConfigPipe
                    :is-new-lld="isNewLld"
                    :lld="lld"
                    :system-settings="systemSettings"
                    :options="options"
                    @dataChanged="onDataChanged" />
                </v-tab-item>
                <v-tab
                  :key="2"
                  ripple>
                  {{ $t('Leak test') }}
                  <v-icon>mdi-water</v-icon>
                </v-tab>
                <v-tab-item
                  :key="2">
                  <MaglinkLineLeakConfigTests
                    :is-new-lld="isNewLld"
                    :lld="lld"
                    :system-settings="systemSettings"
                    @dataChanged="onDataChanged" />
                </v-tab-item>
                <v-tab
                  :key="3"
                  ripple>
                  {{ $t('Relays') }}
                  <v-icon>mdi-chip</v-icon>
                </v-tab>
                <v-tab-item
                  :key="3">
                  <MaglinkLineLeakRelays
                    :is-new-lld="isNewLld"
                    :options="options"
                    :relays="lld.relays"
                    :site-info="siteInfo"
                    @dataChanged="onDataChanged" />
                </v-tab-item>
                <v-tab
                  :key="4"
                  ripple>
                  {{ $t('STP shutdown') }}
                  <v-icon>mdi-close-network</v-icon>
                </v-tab>
                <v-tab-item
                  :key="4">
                  <MaglinkLineLeakShutdown
                    :lld="lld"
                    :options="options"
                    :site-info="siteInfo"
                    :system-settings="systemSettings"
                    :shutdown-data="lld.stpShutdowns"
                    :devices="devices"
                    @dataChanged="onDataChanged" />
                </v-tab-item>
              </v-tabs>
            </v-flex>
          </div>
          <v-container>
            <v-layout justify-row-center>
              <MaglinkComponentDialogYesNo
                :key="dialogYN.key"
                :component-key="dialogYN.componentKey"
                :dialog="dialogYN.show"
                :title="dialogYN.title"
                :label-text="dialogYN.labelText"
                :custom-par1="dialogYN.action"
                :custom-par2="dialogYN.result"
                :custom-par3="dialogYN.lld"
                @dialogResultYesNo="onDialogResult"/>
              <v-flex
                xs12
                md12
                lg12
                text-xs-center>
                <v-btn
                  :disabled="saveDisabled"
                  small
                  class="mx-0 font-weight-light"
                  color="dover-blue"
                  @click="onSave()">
                  {{ $t('Save') }}
                </v-btn>
              </v-flex>
              <v-flex
                xs12
                md12
                lg12
                text-xs-center>
                <v-btn
                  :disabled="isNewLld"
                  small
                  class="mx-0 font-weight-light"
                  color="dover-red"
                  @click="onDelete()">
                  {{ $t('Delete') }}
                </v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </material-card>
      </v-flex>
    </div>
  </material-card>
</template>

<script>

import { i18n } from '@/i18n'

export default {
  props: {
    isNewLld: {
      type: Boolean,
      require: true,
      default: () => false
    },
    lld: {
      type: Object,
      required: false,
      default: () => {}
    },
    llds: {
      type: Object,
      required: false,
      default: () => []
    },
    systemSettings: {
      type: Object,
      required: true,
      default: () => {}
    },
    tanks: {
      type: Array,
      required: true,
      default: () => []
    },
    sensors: {
      type: Array,
      required: true,
      default: () => []
    },
    siteInfo: {
      type: Object,
      required: true,
      default: () => {}
    },
    options: {
      type: Object,
      required: true,
      default: () => {}
    },
    componentKey: {
      type: Number,
      required: true,
      default: () => 0
    }
  },
  data: () => ({
    baseLldTemplate: {
      lldNumber: 0,
      lldDescription: i18n.t('New Line'),
      enabled: false,
      tankNumber: 1,
      limStpAddress: 0,
      limStpPosition: 0,
      ioSensorAddress: 1,
      ioSensorPosition: 0,
      sensorSpan: 87.00,
      lineBeta: 0.00,
      lineCalibratedBeta: 0.00,
      lineLength: 0.00,
      lineSegmentVolume: 0.00,
      minimumDispensingPressure: 16.00,
      minimumTestPressure: 20.00,
      shutdownEnableMask: 0x01,
      retestLimit: 0,
      autoLeakTestEnabled: false,
      autoLeakTestRepetition: 0,
      autoLeakTestWarning01: 0,
      autoLeakTestWarning02: 0,
      relays: [],
      stpShutdowns: []
    },
    dialogYN: {
      key: 0,
      show: false,
      componentKey: '',
      title: '',
      labelText: '',
      action: '',
      result: '',
      lld: undefined
    },
    saveDisabled: true,
    devices: []
  }),
  watch: {
    tanks: {
      handler: function (newTanks, oldTanks) {
        this.updateDevices()
      },
      immediate: true
    },
    llds: {
      handler: function (newLlds, oldLlds) {
        this.updateDevices()
      },
      immediate: true
    },
    sensors: {
      handler: function (newSensors, oldSensors) {
        this.updateDevices()
      },
      immediate: true
    }
  },
  mounted () {
    if (this.isNewLld) {
      this.resetLld()
    }
  },
  methods: {
    updateDevices () {
      this.devices = []
      var i
      for (i = 0; i < this.tanks.length; i++) {
        this.devices.push({ code: i + 1, deviceType: 0, deviceNumber: this.tanks[i].tankNumber, desc: this.$t('Tank') + ' ' + this.tanks[i].tankNumber + ' - ' + this.tanks[i].tankDescription })
      }
      var n = this.tanks.length
      for (i = 0; i < this.llds.length; i++) {
        this.devices.push({ code: n + i + 1, deviceType: 4, deviceNumber: this.llds[i].lldNumber, desc: this.$t('Line') + ' ' + this.llds[i].lldNumber + ' - ' + this.llds[i].lldDescription })
      }
      n = this.tanks.length + this.llds.length
      for (i = 0; i < this.sensors.length; i++) {
        this.devices.push({ code: n + i + 1, deviceType: 1, deviceNumber: this.sensors[i].sensorNumber, desc: this.$t('Sensor') + ' ' + this.sensors[i].sensorNumber + ' - ' + this.sensors[i].sensorName })
      }
    },
    checkBeforeSave (item) {
      let result = ''
      item.lldNumber = item.lldNumber * 1
      item.tankNumber = item.tankNumber * 1

      for (let i = 0; i < this.llds.length; i++) {
        if (this.isNewLld) {
          if (item.lldNumber === 0) {
            result = this.$t('LLD Number MUST not be 0!')
          } else if (item.lldNumber === this.llds[i].lldNumber) {
            result = this.$t('LLD Number already used!')
          } else {
            result = this.commonCheckBeforeSave(item, this.llds[i])
          }
        } else if (item.lldNumber !== this.llds[i].lldNumber) {
          result = this.commonCheckBeforeSave(item, this.llds[i])
        }

        if (result !== '') {
          return result
        }
      }

      return result
    },
    commonCheckBeforeSave (item, lld) {
      if (item.tankNumber === lld.tankNumber) {
        return this.$t('Selected Tank is already in use!')
      }

      if (item.lldDescription === lld.lldDescription) {
        return this.$t('The LLD Name is already in use!')
      }

      if (item.sensorSpan < 20.00 || item.sensorSpan > 100.00) {
        return this.$t('The Sensor Span is OUTSIDE valid range!')
      }

      if (item.ioSensorAddress === 0) {
        item.ioSensorPosition = 0
      }

      if (item.ioSensorAddress !== 0 && item.ioSensorPosition === 0) {
        return this.$t('MAGLINK I/O Channel MUST be selected!')
      }

      if (item.ioSensorAddress !== 0 && item.ioSensorPosition !== 0) {
        if (item.ioSensorAddress === lld.ioSensorAddress && item.ioSensorPosition === lld.ioSensorPosition) {
          return this.$t('Selected MAGLINK I/O Channel is already in use!')
        }
      }

      if (item.limStpAddress === 0) {
        return this.$t('LIM Output Device MUST be selected!')
      } else {
        if (item.limStpPosition === 0) {
          return this.$t('LIM Output Channel MUST be selected!')
        } else if (item.limStpAddress === lld.limStpAddress && item.limStpPosition === lld.limStpPosition) {
          return this.$t('Selected LIM Output Channel is already in use!')
        }
      }

      if (item.lineLength > 0.00) {
        if (item.lineSegmentVolume === 0.00) {
          return this.$t('The PipeLine is not completely configured!')
        }

        if (item.lineBeta === 0 && item.lineCalibratedBeta === 0) {
          return this.$t('Beta or Calibrated Beta MUST be defined!')
        }
      }

      return ''
    },
    getText () {
      if (this.lld === undefined) {
        this.resetLld()
      }

      return ''
    },
    getTitle () {
      if (this.lld === undefined) {
        this.resetLld()
      }

      return this.lld.lldDescription
    },
    onDataChanged (e) {
      let result = false

      if (this.lld === undefined) {
        result = true
      } else if (this.lld.lldNumber === 0) {
        result = true
      } else {
        result = !e
      }

      this.saveDisabled = result
    },
    onDelete () {
      let text = this.$t('You are about to DELETE selected LLD: {0}', [ this.lld.lldDescription ])

      this.dialogYN.title = this.$t('Warning').toUpperCase()
      this.dialogYN.labelText = '\n\n' + text + '\n\n' + this.$t('Are you sure?')
      this.dialogYN.componentKey = 'delete'
      this.dialogYN.action = 'delete'
      this.dialogYN.result = this.lld.lldNumber.toString()
      this.dialogYN.lld = this.lld
      this.dialogYN.show = true
    },
    onDialogResult (componentKey, result, action, par2, item) {
      this.dialogYN.show = false

      // NO button pressed
      if (!result) return

      // convert to number
      let id = item.lldNumber * 1
      this.Maglink.DeleteLld(id)
        .then(response => {
          let text = this.$t('LLD {0} deleted successfully', [ item.lldDescription ])
          this.snack('success', text)
          this.$emit('lldDeleted', this.lld)
        })
        .catch(error => (this.snack('error', error.message)))
    },
    onSave () {
      let checkMessage = this.checkBeforeSave(this.lld)
      if (checkMessage !== '') {
        this.snack('error', checkMessage)
        return
      }

      this.Maglink.SaveLld(this.lld)
        .then(response => {
          let text = this.$t('LLD {0} saved successfully', [ this.lld.lldDescription ])
          this.snack('success', text)
          this.$emit('lldSaved', this.lld)
          this.onDataChanged(false)
          if (this.isNewLld) {
            this.resetLld()
          }
        })
        .catch(error => (this.snack('error', error.message)))
    },
    resetLld () {
      this.saveDisabled = true
      this.onDataChanged(false)
      this.lld = Object.assign({}, this.baseLldTemplate)
    },
    snack (color, message) {
      message = i18n.t('Line leak config') + ': ' + message
      this.$store.dispatch('showSnackbar', { color, message, show: true })
    }
  }
}
</script>
